<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <!--
            <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
              <i class="pi pi-arrow-left"></i>
            </button>
          -->
          <h2 class="title-main">{{'UserPages.UserLoadPalletsOrders.PageTitle' | translate}}</h2>
        </div>
        <div class="col-12 md:col-6 p-fluid flex align-items-center">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
          </span>
        </div>
        <div>
        </div>
      </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadPalletsOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="exportExcel(loadPalletsTable)"
            [loading]="loading"
            tooltipPosition="bottom"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">{{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid-filters">
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'containerNumber', 'in')"
                    [filter]="true"
                    [(ngModel)]="selectedContainers"
                    [showClear]="false"

                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'week', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'importer', 'in')"
                    [filter]="true"
                    [(ngModel)]="selectedCompanies"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'species', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'variety', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    (onChange)="loadPalletsTable.filter($event.value, 'ship', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadPalletsOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                  id="year-filter"
                  [options]="years"
                  [(ngModel)]="yearSelect"
                  class="multiselect"
                  [selectionLimit]="1"
                  (onChange)="searchLoadContainers($event)"
                  placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                  >
                  </p-multiSelect>
                  <label for="year-filter">
                    {{'MyLoadFilter.YearLabel' | translate}}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadPalletsTable
              [value]="filteredRegisters"
              dataKey="product.pallet.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              [resizableColumns]="true"
              columnResizeMode="expand"
              scrollHeight="800px"
              (onFilter)="filterTable($event)"
              [tableStyle]="{ 'min-width': '50rem' }"
              [showCurrentPageReport]="true"
              [globalFilterFields]="['containerNumber', 'week', 'importer', 'species', 'variety', 'ship']"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.ImportOrderIdHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.ImporterHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.WeeksHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.ETAHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.ETDHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.ContainerHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.PalletsHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.GrowerHeader' | translate}}</th>
                  <th>CSG</th>
                  <th>CSP</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.EspecieHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.VarietyHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.PackagingHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.NetKilosHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.LabelHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.BoxesPerPalletHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.VesselNameHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.OriginPortHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.DestinationPortHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.PricePerBox' | translate}}</th>
                  <th>{{'UserPages.UserLoadPalletsOrders.MainTable.Incoterms' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.importOrderId }}</td>
                  <td>{{ product.importer }}</td>
                  <td>{{ product.week }}</td>
                  <td>{{ product.etd | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.eta | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.containerNumber }}</td>
                  <td>{{ product.palletNumber }}</td>
                  <td>{{ product.producer }}</td>
                  <td>{{ product.csg }}</td>
                  <td>{{ product.csp }}</td>
                  <td>{{ product.species }}</td>
                  <td>{{ product.variety }}</td>
                  <td>{{ product.packaging }}</td>
                  <td>{{ product.netKilos }}</td>
                  <td>{{ product.tag }}</td>
                  <td>{{ product.boxesPerPallet }}</td>
                  <td>{{ product.ship }}</td>
                  <td>{{ product.departurePort }}</td>
                  <td>{{ product.destinationPort }}</td>
                  <td>$ {{ product.importOrderDetail?.price }}</td>
                  <td>{{ product.incoterms }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>
